import useAllWorkspaceLabelList from '@app/features/label/hooks/useAllWorkspaceLabelList';
import { Label } from '@app/features/label/types';

export default function useGetLabelListByIds({ labelIds }: { labelIds: string[] }) {
  const { data: accessibleLabels, isLoading, error } = useAllWorkspaceLabelList({});

  const labels = accessibleLabels?.filter((alb) => labelIds.includes(alb.id)) as Label[];

  return {
    labels,
    isLoading,
    error,
    isAllLabelAccessible: isLoading || labels.length === labelIds.length,
  };
}
